export default "__VITE_ASSET__ChOfGACU__"